<button
  class="primary open-contacts-btn"
  color="primary"
  (click)="onOpenListClicked()"
>
  {{ searchType }} LIST
</button>
